import type { NavBarExtension } from '@pflegenavi/frontend/layout';
import { useFeatureFlag } from '@pflegenavi/frontend/feature-flags';
import { FeatureFlag, FeatureFlagStatus } from '@pflegenavi/shared/api';
import { nhAppMainPages } from '@pflegenavi/frontend/routing';
import { Iconify } from '@pflegenavi/web-components';
import { useTranslation } from 'react-i18next';

// Unlike the expense management section, budgets are also visible to
// employees (read-only), so there is no role gate here.
export const useBudgetsNavConfig: () => NavBarExtension = () => {
  const expenseManagementEnabled =
    useFeatureFlag(FeatureFlag.ExpenseManagement) === FeatureFlagStatus.Enabled;

  const { t } = useTranslation();

  if (!expenseManagementEnabled) {
    return undefined;
  }

  return {
    item: {
      icon: <Iconify icon="tabler:chart-pie" width={24} height={24} />,
      title: t('budgets.page-title'),
      path: nhAppMainPages.BUDGETS,
    },
  };
};
